import React, { useEffect, useState } from 'react';
import { useDashboardContext } from '../../../components/providers/DashboardProvider';
import { Box, Skeleton, Typography } from '@mui/material';
import { HubOutlined } from '@mui/icons-material';

import CopyableTypography from './CopyableTypography';
import BlockInfoCard from './BlockInfoCard';

const DevicesPage = () => {

  const { pollingCounter } = useDashboardContext();
  const [init, setInit] = useState(true);

  const {
    fetchClusterComponentsTree, componentsTree,
  } = useDashboardContext();

  const runRoutine = async () => {
    console.log("Polling in Components");
    fetchClusterComponentsTree();
  }

  useEffect(() => {
    if (init) {
      console.log("Initializing Devices page...");
      if (componentsTree == null) {
        console.log("First poll...");
        runRoutine();
      }
      setInit(value => false);
    } else {
      if (pollingCounter != 0) {
        runRoutine();
      }
    }
  }, [pollingCounter]);

  const blocks = componentsTree?.blocks || [];

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={2}
      sx={{ pt: 2 }}
    >
      {/* Cluster header */}
      <Box sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 1.5,
        px: 2.5,
        py: 2,
        backgroundColor: "var(--c-surface)",
        border: "1px solid var(--c-border)",
        borderRadius: "16px",
      }}>
        <HubOutlined sx={{ color: "var(--c-brand)" }} />
        <Box sx={{ flex: 1, minWidth: 160 }}>
          <Typography sx={{ fontSize: 15, fontWeight: 600, color: "var(--c-text)", lineHeight: 1.3 }}>
            Devices
          </Typography>
          <Typography sx={{ fontSize: 13, color: "var(--c-text-muted)", lineHeight: 1.4 }}>
            {componentsTree
              ? `${blocks.length} block${blocks.length === 1 ? "" : "s"} in this cluster`
              : "Loading devices…"}
          </Typography>
        </Box>
        {componentsTree?.cluster_id && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography sx={{ fontSize: 13, color: "var(--c-text-muted)" }}>Cluster ID</Typography>
            <CopyableTypography
              text={componentsTree.cluster_id}
            />
          </Box>
        )}
      </Box>

      {/* Blocks */}
      {componentsTree == null
        ? Array.from({ length: 2 }).map((_, i) => (
          <Skeleton key={i} variant="rounded" height={220} sx={{ borderRadius: "16px" }} />
        ))
        : blocks.map((blockInfo, index) =>
          <BlockInfoCard
            key={index}
            blockInfo={blockInfo}
          />
        )
      }
    </Box>
  )
}

export default DevicesPage;
